export const hasAndroidCompatibleDevice = devices =>
  devices.some(d => d.android === 'supported');

export const hasSelectedMobileCompatibleDevice = (platform, selectedDevices) =>
  platform !== 'none' &&
  selectedDevices.some(device => device[platform] === 'supported');

export const hasUploaderCompatibleDevice = selectedDevices =>
  selectedDevices.some(device => device.uploader === 'supported');
